// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1643":"015ba90f73c9cd81","2330":"77b058be96387fce","3100":"7cc7fd6ead42e898","5252":"efb0725b1ad04ac1"}[chunkId] + ".js";
};